import React from 'react';

function MaterialIcon(props) {
	return (
		<i className={`material-icons ${props.className ? props.className : ''}`} data-type={props.children}>
			{props.children}
		</i>
	);
}

export default MaterialIcon;
